import { memo } from "react";
import TransactionList from "ui/organizms/TransactionList";

const TransactionListScreen = () => (
    <TransactionList />
);

export default memo(TransactionListScreen);
